module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon_write-cf1753584a89b2c05ac53200e63829c3.svg";